import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserImpersonationService } from '../services/user-impersonation.service';
import { AccessRightDomainStore } from '../stores/access-right.store';
import { AssetGroupStore } from '../stores/asset-group.store';
import { AssetTypeStore } from '../stores/asset-type.store';
import { AssetStore } from '../stores/asset.store';
import { UserStore } from '../stores/user.store';

@Injectable({
  providedIn: 'root',
})
export class HomeResolver implements Resolve<void> {
  private readonly assetStore = inject(AssetStore);
  private readonly assetTypeStore = inject(AssetTypeStore);
  private readonly assetGroupStore = inject(AssetGroupStore);
  private readonly accessRightStore = inject(AccessRightDomainStore);
  private readonly authService = inject(AuthService);
  private readonly impersonationService = inject(UserImpersonationService);
  private readonly userStore = inject(UserStore);

  async resolve(): Promise<void> {
    await Promise.all([this.assetGroupStore.loadAll(), this.assetStore.loadAll(), this.assetTypeStore.loadAll()]);

    await this.authService.waitForUsers();

    const effectiveUserId = this.impersonationService.getEffectiveUserId(this.authService.currentUserId());
    if (!effectiveUserId) return;

    const isImpersonating = this.impersonationService.isImpersonating();
    const user = this.userStore.byId()(effectiveUserId);
    if (user?.isAdmin && !isImpersonating) return;

    await this.accessRightStore.loadByUserId(effectiveUserId);
  }
}
